export const ERROR = {
  MESSAGE: {
    RATING: "Status update not allowed.", //クルーが報告を取り下げたタイミングと、依頼者が確認完了（1件ずつ）を実施するタイミングが重なってしまった時
    RATING_BULK: "Status update not allowed." //クルーが報告を取り下げたタイミングと、依頼者が一括確認完了を実施するタイミングが重なってしまった時
  }
};
